import {
  AboutUs,
  Careers,
  ContactUs,
  CookieNotice,
  Landing,
  TermsAndConditions,
} from 'features/misc';
import { useAuth } from 'lib/auth';
import { useRoutes } from 'react-router-dom';
import { lazyImport } from 'utils/lazyImport';
import { protectedRoutes } from './protected';
import { publicRoutes } from './public';

const { ProjectsRoutes } = lazyImport(() => import('features/projects'), 'ProjectsRoutes');
const { DesignsRoutes } = lazyImport(() => import('features/designs'), 'DesignsRoutes');

export const AppRoutes = () => {
  const auth = useAuth();

  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/about-us', element: <AboutUs /> },
    { path: '/contact-us', element: <ContactUs /> },
    { path: '/careers', element: <Careers /> },
    { path: '/cookie-notice', element: <CookieNotice /> },
    { path: '/terms-and-conditions', element: <TermsAndConditions /> },
    {
      path: '/construction/*',
      element: <ProjectsRoutes />,
    },
    {
      path: '/designs/*',
      element: <DesignsRoutes />,
    },

    // { path: '/projects', element: <Projects /> },
  ];

  const routes = auth.user ? protectedRoutes : publicRoutes;

  const element = useRoutes([...routes, ...commonRoutes]);

  return <>{element}</>;
};
